<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @del="batchdel"
                    ref="SetBtn"></buttonlist>
        <div>
            <el-table
                    id="xpane-0"
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    @selection-change="handleSelectionChange"
                    style="width: 100%; margin-top:0px"
                    :header-cell-style="$limits.headerClass"
                    ref="singleTable"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Code" :label="$t('getapi[1832]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Name" :label="$t('getapi[1191]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="superiorCode"
                                 :label="$t('getapi[3158]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="superiorName"
                                 :label="$t('getapi[3159]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="InEmail" :label="$t('getapi[3160]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="CSex" :label="$t('getapi[3161]')">
                    <template scope="scope">
                        <span>{{ scope.row.CSex | lanchange}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="Birthday" :label="$t('getapi[3162]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Addr" :label="$t('getapi[3163]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Tel1" :label="$t('getapi[3164]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="CdepNM" :label="$t('getapi[3151]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="CpostNM" :label="$t('getapi[3165]')"></el-table-column>
                <el-table-column prop="InDutyDate" :label="$t('getapi[3166]')">
                    <template scope="scope">
                        <span>{{ scope.row.InDutyDate | toDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="OutDutyDate" :label="$t('getapi[3179]')">
                    <template scope="scope">
                        <span>{{ scope.row.OutDutyDate | toDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="leave_flag" :label="$t('getapi[12368]')">
                    <template scope="scope">
                        <span>{{ scope.row.leave_flag | lanchange}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="$t('getapi[6048]')" width="60">
                    <template slot-scope="scope">
                        <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text"
                                   size="small">{{ $t('getapi[34]') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row class="page">
                <el-col :span="18">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[100, 200, 300, 400]"
                            :page-size="pageSize"
                            :pager-count="5"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                    ></el-pagination>
                </el-col>
                <el-col :span="6">
                    <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                        }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <serce :isVisible="isVisible" queryData="sysemployeeinfoViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- 详情页面 -->
        <el-dialog v-dialogDrag :visible.sync="isShowEdit" width="40%" :close-on-click-modal="false"  :modal-append-to-body="false" :append-to-body="true">
            <table>
                <tr>
                    <td>{{ $t('getapi[1832]') }}</td>
                    <td>
                        <el-input v-model="dataDetailInfo.code" type="text" size="mini"></el-input>
                    </td>
                    <td>{{ $t('getapi[1191]') }}</td>
                    <td>
                        <el-input v-model="dataDetailInfo.name" type="text" size="mini" oninput="value=value.replace(/[()]/g,'')"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[3158]') }}</td>
                    <td>
                        <el-input
                                v-model="dataDetailInfo.superiorcode"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee4()"></i>
                        </el-input>
                    </td>
                    <td>{{ $t('getapi[3159]') }}</td>
                    <td>
                        <el-input v-model="dataDetailInfo.superiorname" type="text" size="mini"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[3162]') }}</td>
                    <td>
                        <el-date-picker v-model="dataDetailInfo.birthday" value-format="yyyy-MM-dd" type="date" size="mini"
                                        style="width:100%"></el-date-picker>
                    </td>
                    <td>{{ $t('getapi[3161]') }}</td>
                    <td>
                        <template>
                            <el-radio v-model="dataDetailInfo.sex" :label="true">{{ $t('getapi[3175]') }}</el-radio>
                            <el-radio v-model="dataDetailInfo.sex" :label="false">{{ $t('getapi[3174]') }}</el-radio>
                        </template>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[3163]') }}</td>
                    <td colspan="3">
                        <el-input v-model="dataDetailInfo.addr" type="text" size="mini"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[3178]') }}</td>
                    <td>
                        <el-input v-model="dataDetailInfo.tel1" type="text" size="mini"></el-input>
                    </td>
                    <td>{{ $t('getapi[3177]') }}</td>
                    <td>
                        <el-input v-model="dataDetailInfo.tel2" type="text" size="mini"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[3151]') }}</td>
                    <td>
                        <routejump :urlNo="28" :isDialog="1" @callback="beforeRoutJump">
                        <el-select filterable v-model="dataDetailInfo.department_id" size="mini" @change="getPost">
                            <el-option v-for="item in DepartmentInfo" :key="item.Code" :label="item.Name"
                                       :value="item.Code"></el-option>
                        </el-select>
                        </routejump>
                    </td>
                    <td>{{ $t('getapi[3180]') }}</td>
                    <td>
                        <routejump :urlNo="47" :isDialog="1" @callback="beforeRoutJump">
                        <el-select filterable multiple v-model="postarr" size="mini">
                            <el-option v-for="item in PostInfo" :key="item.num" :label="item.Name"
                                       :value="item.num"></el-option>
                        </el-select>
                        </routejump>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[3166]') }}</td>
                    <td>
                        <el-date-picker v-model="dataDetailInfo.indutydate" type="date" size="mini" value-format="yyyy-MM-dd"
                                        style="width:100%"></el-date-picker>
                    </td>
                    <td>{{ $t('getapi[3160]') }}</td>
                    <td>
                        <el-input v-model="dataDetailInfo.inemail" type="text" size="mini"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[3179]') }}</td>
                    <td>
                        <el-date-picker v-model="dataDetailInfo.outdutydate" type="date" size="mini" value-format="yyyy-MM-dd"
                                        style="width:100%"></el-date-picker>
                    </td>
                    <td>{{ $t('getapi[3176]') }}</td>
                    <td>
                        <el-input v-model="dataDetailInfo.outemail" type="text" size="mini"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[8220]') }}</td>
                    <td>
                        <el-checkbox v-model="dataDetailInfo.limituser"></el-checkbox>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[143]') }}</td>
                    <td colspan="3">
                        <el-input v-model="dataDetailInfo.remarks" type="textarea" size="mini"></el-input>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <el-checkbox v-model="buyer">{{ $t('getapi[1167]') }}</el-checkbox>
                        <el-checkbox v-model="planer">{{ $t('getapi[163]') }}</el-checkbox>
                        <el-checkbox v-model="hander">{{ $t('getapi[2431]') }}</el-checkbox>
                        <el-checkbox v-model="saler">{{ $t('getapi[2598]') }}</el-checkbox>
                    </td>
                </tr>
            </table>

            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="save">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <!--人员-->
        <!--<employee :isVisible="employeeVisible" @getemployee="getemployee" ref="employee"></employee>-->
        <selector :isVisible="employeeVisible" :isBatch=false  :isSplitPage="true" :selectType="4"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getemployee" ref="employee"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'sysemployee',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('sysemployee'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    RoleInfo: [],
                    Info: []
                }, // 编辑页面数据详情
                oldDataDetail:{},
                dataDetailInfo: {},
                isEdit: true, // 是否新增操作
                DepartmentInfo: [],
                PostInfo: [],
                buyer: false, // 采购
                planer: false, // 计划
                hander: false, // 库存
                saler: false, // 销售
                employeeVisible: false,
                selectIDData: [],
                selectData: [],
                btn: {
                    del: false,
                    edit: false
                },
                postarr: [],
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.DepartmentInfo = Array.methods.getDepartmentInfo();
            /*that.PostInfo = Array.methods.getPostInfo();*/
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1065]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.ReadOnlyRights('plv2', 4, 1)) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                //操作权
                let ilimits = that.$limits.UnOperationAuthority('plv2', 4, 1);
                // limits说明：、2 编辑权限、3 删除权限
                switch (ilimits) {
                    case 2:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        break;
                    case 3:
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                        break;
                    default:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('sysemployee',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'sysemployeeinfoViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Sys/Currency/EmployeeDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                that.isShowEdit = true;
                that.isEdit = true;
                that.getDetail(row.Code);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                that.buyer = false;
                that.planer = false;
                that.hander = false;
                that.saler = false;
                let parm = {
                    Code: code
                };
                that.$http.urlpost('/Sys/Currency/EmployeeInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        if (that.dataDetail.Info.length > 0) {
                            that.dataDetailInfo = that.dataDetail.Info[0];
                        }
                        that.dataDetailInfo.department_id = parseInt(that.dataDetailInfo.department_id)
                        that.dataDetailInfo.post_id
                        that.postarr = []
                        if(that.dataDetailInfo.post_id.length > 0){
                            that.postarr = that.dataDetailInfo.post_id.split(',')
                            for(let i = 0;i< that.postarr.length;i++){
                                that.postarr[i] = parseInt(that.postarr[i])
                            }
                        }

                        that.getPost(that.dataDetailInfo.department_id,that.dataDetailInfo.code)
                        if (that.dataDetail.RoleInfo.length > 0) {
                            for (let i = 0; i < that.dataDetail.RoleInfo.length; i++) {
                                if (that.dataDetail.RoleInfo[i] == 3) {
                                    that.buyer = true;
                                }
                                if (that.dataDetail.RoleInfo[i] == 5) {
                                    that.planer = true;
                                }
                                if (that.dataDetail.RoleInfo[i] == 7) {
                                    that.hander = true;
                                }
                                if (that.dataDetail.RoleInfo[i] == 11) {
                                    that.saler = true;
                                }
                            }
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.isEdit = false;
                that.isShowEdit = true;
                that.buyer = false;
                that.planer = false;
                that.hander = false;
                that.saler = false;
                that.dataDetailInfo = {
                    num: 0,
                    code: '',
                    name: '',
                    birthday: '',
                    sex: true,
                    addr: '',
                    tel1: '',
                    tel2: '',
                    inemail: '',
                    outemail: '',
                    remarks: '',
                    indutydate: '',
                    outdutydate: '',
                    department_id: '',
                    post_id: '',
                    superiorcode: '',
                    superiorname: null,
                    module_field: null,
                    createruser: that.user,
                    createtime: that.dateTime,
                    limituser:false
                };
                that.dataDetailInfo = {...that.dataDetailInfo};
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
                that.authority();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[1065]')
                };
                that.$http.urlpost('Sys/Currency/EmployeeExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                let str = ''
                for(let i=0;i<that.postarr.length;i++){
                    str = str + that.postarr[i] + ','
                }
                that.dataDetailInfo.post_id = str.substring(0,str.length-1)
                let parm = [];
                parm = [
                    ...parm,
                    {
                        num: that.dataDetailInfo.num,
                        code: that.dataDetailInfo.code,
                        superiorcode: that.dataDetailInfo.superiorcode,
                        name: that.dataDetailInfo.name,
                        sex: that.dataDetailInfo.sex,
                        birthday: that.dataDetailInfo.birthday,
                        addr: that.dataDetailInfo.addr,
                        tel1: that.dataDetailInfo.tel1,
                        tel2: that.dataDetailInfo.tel2,
                        inemail: that.dataDetailInfo.inemail,
                        outemail: that.dataDetailInfo.outemail,
                        remarks: that.dataDetailInfo.remarks,
                        createruser: that.dataDetailInfo.createruser,
                        createtime: that.dataDetailInfo.createtime,
                        updateuser: that.dataDetailInfo.updateuser,
                        updatetime: that.dataDetailInfo.updatetime,
                        isdelete: false,
                        issealed: false,
                        department_id: that.dataDetailInfo.department_id,
                        post_id: that.dataDetailInfo.post_id,
                        indutydate: that.dataDetailInfo.indutydate,
                        outdutydate: that.dataDetailInfo.outdutydate,
                        module_field: that.dataDetailInfo.module_field,
                        buyer: that.buyer == true?1:0,
                        planer: that.planer == true?1:0,
                        hander: that.hander == true?1:0,
                        saler: that.saler == true?1:0,
                        limituser:that.dataDetailInfo.limituser
                    }
                ];
                that.$http.urlpost('/Sys/Currency/SaveEmployee', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.isShowEdit = false;
                        that.getView();
                    }
                });
            },
            //获取采购订单
            selectemployee4() {
                let that = this;
                that.employeeVisible = true;
                that.$refs.employee.clearInput(this.employeeVisible, false, 4);
            },
            getemployee(data) {
                let that = this;
                that.dataDetailInfo.superiorcode = data.code;
                that.dataDetailInfo.superiorname = data.name;
                that.dataDetailInfo = {...that.dataDetailInfo};
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].Code);
                    that.selectData.push(val[i])
                }
                that.authority()
            },
            batchdel() {
                let that = this;
                that.$confirm(this.$t('getapi[6049]'), this.$t('getapi[194]'), {
                    confirmButtonText: this.$t('getapi[1146]'),
                    cancelButtonText: this.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = '';
                        for (let i = 0; i < that.selectIDData.length; i++) {
                            ids = ids + that.selectIDData[i] + ',';
                        }
                        ids = ids.substr(0, ids.length - 1);
                        let parm = {
                            ids: ids,
                            exclusively_id: 0,
                            LangType: that.$processdata.getLang(),
                        };
                        that.$http.urlpost('/Sys/Currency/DelEmployeeByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(Common.SuccessMsg);
                                that.getView();
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            getPost(val,code) {
                let that = this;
                console.log(val)
                /*that.dataDetailInfo.post_id = ''*/
                let name = "";
                for(let i = 0;i<that.DepartmentInfo.length;i++){
                    if(val == that.DepartmentInfo[i].Code){
                        name = that.DepartmentInfo[i].Name
                    }
                }
                let parm = {
                    Name: name,
                    Code:code
                }
                that.$http.urlpost('/Sys/Currency/GetPostListBydepName', parm, function (res) {
                    if (res.Success == 1) {
                        that.PostInfo = res.DataContent.Table
                    }
                });
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isShowEdit = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isShowEdit = false
                    callback(true)
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
